import o from "./blur.mjs";
import r from "./borders.mjs";
import t from "./breakpoints.mjs";
import m from "./colors.mjs";
import i from "./fontSizes.mjs";
import f from "./fontWeights.mjs";
import s from "./fonts.mjs";
import p from "./letterSpacings.mjs";
import n from "./lineHeights.mjs";
import e from "./radii.mjs";
import a from "./shadows.mjs";
import d from "./sizes.mjs";
import c from "./space.mjs";
import l from "./transition.mjs";
import u from "./zIndices.mjs";
const b = {
  breakpoints: t,
  zIndices: u,
  radii: e,
  blur: o,
  colors: m,
  fonts: s,
  fontSizes: i,
  fontWeights: f,
  letterSpacings: p,
  lineHeights: n,
  sizes: d,
  shadows: a,
  space: c,
  borders: r,
  transition: l
}, A = b;
export {
  A as default
};
